import react from "react";
import "./style.less"
import 'rc-texty/assets/index.css';
import {Card, Carousel} from "antd";

const {Meta} = Card;

export default class MobileContent0 extends react.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="Mobile-datalink-content0">
                <Carousel autoplay>
                    <Card
                        style={{width: 240, padding: "0 12px"}}
                        cover={<img alt="example" style={{width: 330, margin: "0 auto"}}
                                    src="http://qiniu.metridynamic.com/image/datalink/d1.png"/>}
                    >
                        <Meta title="自动追踪天线"
                            description="自动跟踪定向天线在工作时，始终面向飞行器的方向，以保证最佳的通信信号强度。适合远距离通信，50km 及以上控制距离可选。"/>
                    </Card>
                    <Card

                        style={{width: 240}}
                        cover={<img alt="example" style={{width: 330, margin: "0 auto"}}
                                    src="http://qiniu.metridynamic.com/image/datalink/d2.png"/>}
                    >
                        <Meta title="全向定向一体天线"
                            description="全定一体天线工作时，全向天线会在360度方向上收发信号， 同时结合定向平板进行传输，系统会自动选择任意一个时间点信号最强的通道进行传输，地面定向天线需要手动进行方向调整，适用于30km及以下的通信范围。"/>
                    </Card>
                </Carousel>
            </div>
        )
    }
}
